import * as React from "react";
import type { SVGProps } from "react";
const SvgLoader = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 2a1 1 0 1 0-2 0zm-2 4a1 1 0 1 0 2 0zm2 12a1 1 0 1 0-2 0zm-2 4a1 1 0 1 0 2 0zM5.637 4.223a1 1 0 0 0-1.414 1.414zm1.416 4.244a1 1 0 0 0 1.414-1.414zm9.894 7.066a1 1 0 0 0-1.414 1.414zm1.416 4.244a1 1 0 0 0 1.414-1.414zM2 11a1 1 0 1 0 0 2zm4 2a1 1 0 1 0 0-2zm12-2a1 1 0 1 0 0 2zm4 2a1 1 0 1 0 0-2zM4.223 18.363a1 1 0 1 0 1.414 1.414zm4.244-1.416a1 1 0 1 0-1.414-1.414zm7.066-9.894a1 1 0 0 0 1.414 1.414zm4.244-1.416a1 1 0 0 0-1.414-1.414zM11 2v4h2V2zm0 16v4h2v-4zM4.223 5.637l2.83 2.83 1.414-1.414-2.83-2.83zm11.31 11.31 2.83 2.83 1.414-1.414-2.83-2.83zM2 13h4v-2H2zm16 0h4v-2h-4zM5.637 19.777l2.83-2.83-1.414-1.414-2.83 2.83zm11.31-11.31 2.83-2.83-1.414-1.414-2.83 2.83z"
    />
  </svg>
);
export default SvgLoader;
